module.exports = __webpack_public_path__ + "media/customizations/svlaliving/logo-new-c8e9e805d6a6eb2364cdec4ba37296fa.png";